module.exports = __webpack_public_path__ + "static/img/6.4534465.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/eng/6.png
// module id = 4Dy4
// module chunks = 0